<template>
	<div class="brick">
		<div class="list_top_box">
			<ItemClassSelectMultiS ref="ItemClassSelectMultiS" :multiSelect="true" v-model="item_classes" />

			<em class="lt_text">Months of Sales: </em>
			<span class="mgr_10">
				<select class="tbl_select sssm_int" v-model="months_of_sales">
					<option v-for="i in 10" :key="i" :value="2 + i">{{ 2 + i }}</option>
				</select>
			</span>

			<em class="lt_text">Months for Reorder Qty: </em>
			<span class="mgr_15">
				<currency-input type="text" style="width:80px;" v-model.trim="months_for_calc" :precision="1" :allow-negative="false" class="int_type al_right" @focus="$event.target.select()" />
			</span>

			<a href="javascript:;" class="search_bt mgr_5" @click="search()">Search</a>
			<a href="javascript:;" class="gray_bt mgr_15" @click="reset()">Reset</a>

			<font color="red"><b>Takes long time without search condition(s) </b></font>
		</div>

		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%">
				<table class="list_tbl sticky_list_tbl">
					<thead>
						<tr>
							<th v-for="(prop, index) in excel_headers" :key="index">{{ prop.name }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(res, index) in result_list" :key="index">
							<template v-for="(prop, jIndex) in excel_headers">
								<td v-if="prop.dataType == defaultDataType.currency" class="al_right" :key="index + '/' + jIndex">{{ res[prop.key] | commaSeparated }}</td>
								<td v-else-if="prop.dataType == defaultDataType.number" class="al_right" :key="index + '/' + jIndex">{{ res[prop.key] | toCurrency }}</td>
								<td v-else class="al_left" :key="index + '/' + jIndex">{{ res[prop.key] }}</td>
							</template>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:;" class="gray_bt" @click="excel()">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiStockVSReorder } from '@/api/report/report.js';
import { defaultDataType } from 'export-xlsx';
import { objectCopy, exportDataExcel } from '@/api/util';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
export default {
	data: () => ({
		result_list: [],
		months_of_sales: 3,
		months_for_calc: 0,

		item_classes: [],

		defaultDataType,
		excel_headers: [],
		default_headers: [
			{ key: 'item_code', name: 'Item No', width: 30, dataType: defaultDataType.string },
			{ key: 'name', name: 'Description', width: 30, dataType: defaultDataType.string },
			{ key: 'avg_sales_qty', name: 'Avg Sales', width: 15, dataType: defaultDataType.currency },
			{ key: 'reorder_qty', name: 'Reorder', width: 15, dataType: defaultDataType.currency },
			{ key: 'po_remain_qty', name: 'On P/O', width: 15, dataType: defaultDataType.currency },
			{ key: 'delivery_qty', name: 'PO Cut', width: 15, dataType: defaultDataType.currency },
			{ key: 'estimated_remain_qty', name: 'PO+Cut+Stock-SO', width: 15, dataType: defaultDataType.currency },
			{ key: 'on_hand', name: 'Stock', width: 15, dataType: defaultDataType.currency },
			{ key: 'on_order_quantity', name: 'On S/O', width: 15, dataType: defaultDataType.currency },
			{ key: 'sub_stock_reorder', name: 'Stock-Reorder', width: 15, dataType: defaultDataType.currency },
		],
	}),
	components: {
		ItemClassSelectMultiS,
	},
	methods: {
		makeExcelDisplayData(data) {
			const today = new Date();
			const year = today.getFullYear();
			const month = today.getMonth();

			const excel_headers = objectCopy(this.default_headers);
			for (let i = 0; i < this.months_of_sales + 1; i++) {
				const firstDateOfMonth = new Date(year, month - i, 1);
				const temp_year = firstDateOfMonth.getFullYear();
				const temp_month = firstDateOfMonth.getMonth();
				excel_headers.splice(2, 0, { key: temp_year + '_' + (temp_month + 1), name: temp_year + '/' + (temp_month + 1) + ' MO', width: 10, dataType: defaultDataType.currency });

				if (Array.isArray(data)) {
					data.forEach(el => {
						let idx = -1;
						if (Array.isArray(el.qty_list_by_month)) idx = el.qty_list_by_month.findIndex(e => e.sales_year === temp_year && e.sales_month === temp_month + 1);

						el[temp_year + '_' + (temp_month + 1)] = idx > -1 ? el.qty_list_by_month[idx].sum_sales_qty : 0;
						if (el.estimated_remain_qty === undefined) el.estimated_remain_qty = el.po_remain_qty + el.delivery_qty + el.on_hand - el.on_order_quantity;
						if (el.reorder_qty === undefined) el.reorder_qty = el.estimated_remain_qty - el.avg_sales_qty * this.months_for_calc;
						if (el.sub_stock_reorder === undefined) el.sub_stock_reorder = el.on_hand - el.reorder_qty;
					});
				}
			}

			this.excel_headers = excel_headers;
			this.result_list = Array.isArray(data) ? data : [];
		},
		reset() {
			this.$refs.ItemClassSelectMultiS.reset();

			this.months_of_sales = 3;
			this.months_for_calc = 0;
			this.item_classes = [];
		},
		excel() {
			if (this.result_list.length < 1) return this.$toast.error('No Data to Export.');
			exportDataExcel(this.result_list, this.excel_headers, 'StockVSReorderPoint');
		},
		async search() {
			let { data } = await apiStockVSReorder(this.item_classes, this.months_of_sales);
			this.makeExcelDisplayData(data);
		},
	},
	async created() {
		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_stock_vs_reorder');
		this.$store.commit('setSubTitle', 'Item -> Stock vs. Reorder');
	},
};
</script>

<style></style>
